import _ from 'lodash'

const orderRangeStatuColor = (orders) => {
  let color = ""

  if (_.inRange(orders, 0, 5)) {
    color = "red"
  } else if (_.inRange(orders, 5, 10)) {
    color = "orange"
  } else if (_.inRange(orders, 10, 15)) {
    color = "olive"
  } else if (orders >= 15) {
    color = "green"
  }

  return color
}

export default orderRangeStatuColor


// WEBPACK FOOTER //
// ./src/helpers/OrderRangeStatus.js